'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'link-simple';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e1cd';
var svgPathData = 'M0 256C0 150 86 64 192 64l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-70.7 0-128 57.3-128 128s57.3 128 128 128l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0C86 448 0 362 0 256zm576 0c0 106-86 192-192 192l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c70.7 0 128-57.3 128-128S454.7 128 384 128l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c106 0 192 86 192 192zM192 224l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLinkSimple = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;